export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14739.eb0e2cf6.jpg";